import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UserContextService} from '../app-context/user-context/user-context.service';

@Injectable({
              providedIn: 'root'
            })
export class AccountIdInterceptorService implements HttpInterceptor {

  constructor(private userContextService: UserContextService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userContext = this.userContextService.getUserContext();
    if (userContext && userContext.accountId) {
      request = request.clone({setHeaders: {accountId: userContext.accountId}});
    }
    return next.handle(request);
  }

}
